import { OligoItem, ProjectItem, ScopeEvents } from '../models';
import { isIE } from '../components/common';

function createEvent(eventType: string, params: object): CustomEvent {
  let event: CustomEvent | null = null;
  if (isIE()) {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventType, true, true, params);
  } else {
    event = new CustomEvent(eventType, {
      detail: params,
    });
  }
  return event;
}

type AnalyticsAwareWindow = {
  digitalData?: {
    page?: {
      type: string;
      toolName: string;
    };
  };
} & Window;

type AnalyticsCartAddProduct = {
  addMethod: string;
  categoryId: string;
  categoryName: string;
  designId: string;
  lineName: string;
  title: string;
  price: string;
  quantity: string;
  catalogNumber: string;
  uom: string;
};

type AnalyticsCartAddEvent = {
  products: AnalyticsCartAddProduct[];
};

type BulkUploadEventType = 'bulktool: Bulk Upload' | 'bulktool: Import';

type AnalyticsBulkUploadEvent = {
  CustomLink: {
    linkName: BulkUploadEventType;
  };
};

const BulkUploadAnalyticsEventScopeMap: {[key: string]: BulkUploadEventType } = {
  [ScopeEvents.BULK_UPLOAD_SHOW]: 'bulktool: Bulk Upload',
  [ScopeEvents.BULK_UPLOAD_IMPORT]: 'bulktool: Import',
};

export interface AnalyticsService {
  bootstrap($scope: ng.IScope): void;
}

class AnalyticsServiceImpl implements AnalyticsService {

  constructor(private $window: ng.IWindowService,
              private $document: ng.IDocumentService) {
  }

  public bootstrap($scope: ng.IScope): void {
    const { $window, $document } = this;
    const { window } = $window;
    const { digitalData } = window as AnalyticsAwareWindow;
    if (!digitalData) {
      return;
    }
    const { page } = digitalData;
    if (!page) {
      return;
    }
    const toolName: string = 'Custom Standard DNA Oligos';
    page.type = 'product tool';
    page.toolName = toolName;
    $scope.$on(ScopeEvents.CART_ADD, (event: ng.IAngularEvent, projects: ProjectItem[], sku: string) => {
      const allOligos: OligoItem[] = projects.reduce((acc: OligoItem[], next: ProjectItem) => {
        return [...acc, ...(next.oligos || [])];
      }, [] as OligoItem[]);
      const analyticsCartItems: AnalyticsCartAddProduct[] = allOligos.map((oligo) => {
        const { pricing } = oligo;
        const quantity: number = 1;
        return {
          addMethod: '',
          categoryId: '',
          categoryName: toolName,
          catalogNumber: sku,
          designId: sku,
          title: toolName,
          lineName: 'invitrogen',
          uom: 'EA',
          quantity: `${quantity}`,
          price: pricing && pricing.available ? `${pricing.amount.toFixed(2)}` : '',
        };
      });
      const cartAddAnalyticsEventItem: AnalyticsCartAddEvent = { products: analyticsCartItems };
      $document.get(0).dispatchEvent(createEvent('cartAdd', cartAddAnalyticsEventItem));
    });

    Object.keys(BulkUploadAnalyticsEventScopeMap).forEach((scopeEventKey) => {
      $scope.$on(scopeEventKey, () => {
        const bulkUploadAnalyticsEventItem: AnalyticsBulkUploadEvent = {
          CustomLink: {
            linkName: BulkUploadAnalyticsEventScopeMap[scopeEventKey],
          },
        };
        $document.get(0).dispatchEvent(createEvent('customLinkClicks', bulkUploadAnalyticsEventItem));
      });
    });
  }

}

export const ANALYTICS_SERVICE_NAME = 'analyticsService';
export const AnalyticsServiceFactory = ($window: ng.IWindowService,
                                        $document: ng.IDocumentService): AnalyticsService => {
  return new AnalyticsServiceImpl($window, $document);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0-0!./src/main/script/service/analytics-service.ts